import { defineStore } from "pinia";
import { compareContractDate, IContract } from "@/types/contract";
import axios from "axios";
import { contractsDeadlinesPreviewUrl, contractsDetailUrl, contractsListUrl } from "@/services/api";
import { useNetworkStore } from "@/stores/network";

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useContractsStore = defineStore("contracts", {
    state: () => ({
        loading: false as boolean,
        contracts: [] as IContract[],
    }),
    persist: true,
    getters: {
        isLoading: (state) => state.loading,
        getContracts: (state) => state.contracts.sort(compareContractDate),
        getContractById:
            (state) =>
            (id: number): IContract | undefined =>
                state.contracts.find((contract) => contract.id == id),
        getContractsByCostumerId:
            (state) =>
            (id: number): IContract[] => {
                return state.contracts.filter((contract) => contract.costumer == id);
            },
    },
    actions: {
        async loadContracts() {
            this.loading = true;
            const response = await axios.get(contractsListUrl);
            if (response.status === 200) {
                this.contracts.length = 0;
                this.contracts.push(...(response.data as IContract[]));
            }
            this.loading = false;
            return response;
        },
        async createContract(contract: IContract) {
            const networkStore = useNetworkStore();
            if (networkStore.isOnline) {
                const response = await axios.post(contractsListUrl, contract);
                if (response.status === 201) {
                    this.contracts.push(response.data as IContract);
                }
                return response;
            }
        },
        async updateContract(contract: IContract) {
            const networkStore = useNetworkStore();
            const index = this.contracts.findIndex((c) => c.id === contract.id!);
            if (index >= 0 && networkStore.isOnline) {
                const response = await axios.patch(contractsDetailUrl(contract.id!), contract);
                if (response.status === 200) {
                    this.contracts[index] = response.data;
                }
                return response;
            }
        },
        async getDeadlinePreview(
            contract: IContract,
            seriesStartpoint: string = new Date().toDateString().substring(0, 10)
        ) {
            const networkStore = useNetworkStore();
            if (networkStore.isOnline) {
                return await axios.get(contractsDeadlinesPreviewUrl, {
                    params: {
                        costumer: contract.costumer,
                        contract_date: contract.date,
                        series_startpoint: seriesStartpoint,
                    },
                });
            }
        },
    },
});
